import { jsx as _jsx } from "react/jsx-runtime";
function withQueryRenderer(_a) {
    var _b = _a === void 0 ? {} : _a, ErrorRenderer = _b.ErrorRenderer;
    var enhancer = function (Component) { return function (_a) {
        var error = _a.error, props = _a.props, retry = _a.retry;
        if (error && ErrorRenderer) {
            return _jsx(ErrorRenderer, { retry: retry, error: error }, void 0);
        }
        if (error) {
            throw error;
        }
        return _jsx(Component, { retry: retry, props: props }, void 0);
    }; };
    return enhancer;
}
export default withQueryRenderer;
//# sourceMappingURL=withQueryRenderer.js.map